import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './TabNav.css';

export function TabNav({ activeTab, onTabChange }) {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const TABS = [
    { id: 'home',      label: t('nav.home') },
    { id: 'upcoming',  label: t('nav.upcoming') },
    { id: 'historial', label: t('nav.historial') },
    { id: 'analisis',  label: t('nav.analysis') },
    { id: 'bets',      label: t('nav.bets') },
    { id: 'mundial',   label: t('nav.mundial') },
    { id: 'sistema',   label: t('nav.sistema') },
  ];

  const activeLabel = TABS.find(tab => tab.id === activeTab)?.label || '';

  const handleTabChange = (id) => {
    onTabChange(id);
    setMenuOpen(false);
  };

  return (
    <div className="tabnav-wrapper">

      {/* Desktop */}
      <div className="tabnav">
        {TABS.map(tab => (
          <button
            key={tab.id}
            className={activeTab === tab.id ? 'tab active' : 'tab'}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Mobile */}
      <div className="tabnav-mobile">
        <button
          className="tabnav-burger"
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Menú"
        >
          <span className="burger-active-label">{activeLabel}</span>
          <span className="burger-icon">{menuOpen ? '✕' : '☰'}</span>
        </button>
        {menuOpen && (
          <div className="tabnav-dropdown">
            {TABS.map(tab => (
              <button
                key={tab.id}
                className={activeTab === tab.id ? 'tab-item active' : 'tab-item'}
                onClick={() => handleTabChange(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}
      </div>

    </div>
  );
}
